import { IAdapterConfig } from '@care-portals/api-interfaces';
import { Adapters as BaseAdapters } from './adapters-config';
import { DigitalRxConfig } from './digital-rx.config';
import { MockConfig } from './mock.config';
import { PocketPillsConfig } from './pocketpills.config';
import { JunctionConfig } from './junction.config';
import { RxVortexConfig } from './rx-vortex.config';
import { WellSyncConfig } from './wellsync.config';
import { PharmetikaV2Config } from './pharmetika-v2.config';
import { PrecisionConfig } from './precision.config';
import { BondRxConfig } from './bond-rx.config';
import { BlendConfig } from './blend.config';
import { VitaboomConfig } from './vitaboom.config';
import { PhytogenixConfig } from './phytogenix.config';
import { TmcConfig } from './tmc.config';
import { OptioRxConfig } from './optiorx.config';
import { VSDigitalConfig } from './vsdigital.config';

// Export individual configs for direct access if needed
export { DigitalRxConfig } from './digital-rx.config';
export type { DigitalRxFunctionConfiguration } from './digital-rx.config';
export { RxVortexConfig } from './rx-vortex.config';
export type { RxVortexFunctionConfiguration } from './rx-vortex.config';
export { MockConfig } from './mock.config';
export { PocketPillsConfig } from './pocketpills.config';
export { WellSyncConfig } from './wellsync.config';
export type { WellSyncFunctionConfiguration } from './wellsync.config';
export type { PharmetikaV2FunctionConfiguration } from './pharmetika-v2.config';
export { PrecisionConfig } from './precision.config';
export type { PrecisionFunctionConfiguration } from './precision.config';

export { BondRxConfig } from './bond-rx.config';
export type { BondRxFunctionConfiguration } from './bond-rx.config';

export { BlendConfig } from './blend.config';
export type { BlendFunctionConfiguration } from './blend.config';

export { VitaboomConfig } from './vitaboom.config';
export type { VitaboomFunctionConfiguration } from './vitaboom.config';
export { TmcConfig } from './tmc.config';
export type { TmcFunctionConfiguration } from './tmc.config';

export { OptioRxConfig } from './optiorx.config';
export type { OptioRxFunctionConfiguration } from './optiorx.config';
export { PhytogenixConfig } from './phytogenix.config';
export type { PhytogenixFunctionConfiguration } from './phytogenix.config';
export { VSDigitalConfig } from './vsdigital.config';
export type { VSDigitalFunctionConfiguration } from './vsdigital.config';
// Note: BaseAdapters is not exported directly - use the merged Adapters below

// Export merged Adapters configuration that includes all adapters
// This is the main export that should be used throughout the application
export const Adapters: IAdapterConfig = {
  ...BaseAdapters,
  ...DigitalRxConfig,
  ...MockConfig,
  ...PocketPillsConfig,
  ...RxVortexConfig,
  ...JunctionConfig,
  ...WellSyncConfig,
  ...PharmetikaV2Config,
  ...PrecisionConfig,
  ...BondRxConfig,
  ...BlendConfig,
  ...VitaboomConfig,
  ...TmcConfig,
  ...OptioRxConfig,
  ...PhytogenixConfig,
  ...VSDigitalConfig
};
